import {Box, Container, Input, Stack, styled, TextField} from '@mui/material';
import {grey} from 'styles/color';
import {HeaderText, RoundedButton} from 'components';
import {Text} from 'App';
import {useAPI} from 'api/api';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import axios from 'axios';

const MailSubcription = () => {
  const {t} = useTranslation();
  return (
    <Container style={{marginTop: 140}}>
      <StyledContainer>
        <Stack
          justifyContent="center"
          alignItems="center"
          height="100%"
          spacing={1}
          target="_blank"
          component={'form'}
          method="post"
          action="https://safed.us14.list-manage.com/subscribe/post?u=8e1432d71de81b06c6be1a65c&amp;id=3a515264d3">
          <HeaderText
            isSmall={false}
            textAlign="center"
            sx={{color: (theme) => theme.palette.common.black}}>
            {t('homepage.subcription.title')}
          </HeaderText>
          <Text
            variant="h5regular"
            textAlign={{md: 'left', xs: 'center'}}
            sx={{
              color: (theme) => grey[550],
            }}>
            {t('homepage.subcription.description')}
          </Text>

          <Stack
            direction={{md: 'row', xs: 'column'}}
            spacing={2.25}
            sx={{paddingTop: 7.5, alignItems: 'center'}}>
            <StyledTextField
              placeholder={t('homepage.subcription.input_mail')}
              variant="outlined"
              className="input-mail-sub"
              inputProps={{
                sx: {
                  padding: '12px 14px',
                },
              }}
              name="EMAIL"
              type="email"
            />
            <div aria-hidden="true" style={{display: 'none'}}>
              <input
                type="text"
                name="b_8e1432d71de81b06c6be1a65c_3a515264d3"
                tabIndex="-1"
                value=""
              />
            </div>
            <RoundedButton
              isSmall={false}
              variant="contained"
              value="Subscribe"
              name="subscribe"
              type="submit"
              style={{padding: '13.5px 34px'}}>
              {t('homepage.subcription.subcribe')}
            </RoundedButton>
          </Stack>
        </Stack>
      </StyledContainer>
    </Container>
  );
};

const StyledContainer = styled(Container)(({theme}) => ({
  background: grey[150],
  height: theme.spacing(36.75),

  [theme.breakpoints.down('md')]: {
    height: theme.spacing(47.25),
  },
}));

const StyledTextField = styled(TextField)(({theme}) => ({
  width: theme.spacing(60),
  height: theme.spacing(6),
  [theme.breakpoints.down('md')]: {
    width: theme.spacing(35),
  },
}));

export {MailSubcription};
